import { render, staticRenderFns } from "./BudgetsListMentor.vue?vue&type=template&id=49186cf3&"
import script from "./BudgetsListMentor.vue?vue&type=script&lang=js&"
export * from "./BudgetsListMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports